export const MITEL_CONNECTION_CHANGED = 'MITEL_CONNECTION_CHANGED'
export const SET_MITEL_CALL_CODE = 'SET_MITEL_CALL_CODE'
export const SET_MITEL_CALLER_NAME = 'SET_MITEL_CALLER_NAME'
export const SET_MITEL_CALLER_NUMBER = 'SET_MITEL_CALLER_NUMBER'


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutation-types.js